import axios from 'axios';
import { onRequestFulfilled } from './onRequestFulfilled';
import { onResponseRejected } from './onResponseRejected';

const request = axios.create({ withCredentials: true });

request.interceptors.request.use(onRequestFulfilled, (error) => error);
request.interceptors.response.use((response) => response, onResponseRejected);

export default request;
